import React from "react";
import { connect } from "react-redux";
import { Field } from "redux-form";
import { FormGroup, Label, Collapse } from "reactstrap";
import Aux from "../../../system/containers/Aux";
import Wysiwyg from "../../../system/fields/Wysiwyg";
import FileUpload from "../../../system/fields/FileUpload";

class Image extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
  }
  state = {
    collapse: true
  };
  
  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }
  
  render() {
    return (
      <React.Fragment>
        {!this.state.collapse && (
          <div className="toggle" onClick={this.toggle}>
            <i className="fas fa-eye" /> <span>Expand {this.props.fields.get(this.props.index).section_type.name}</span>
          </div>
        )}
        {this.state.collapse && (
          <div className="toggle" onClick={this.toggle}>
            <i className="fas fa-eye-slash" /> <span>Collapse {this.props.fields.get(this.props.index).section_type.name}</span>
          </div>
        )}
        
        <Collapse isOpen={this.state.collapse}>
          <div className={"top-field"}>
            <Label>Image</Label>
            <Field
              name={`${this.props.section}.image`}
              component={FileUpload}
            />
          </div>
        </Collapse>
      </React.Fragment>
    );
  }
}

export default Image;



// WEBPACK FOOTER //
// ./src/containers/Blogs/components/Image.jsx